import * as Yup from 'yup';

const agentValidation = (t: (key: string) => string) => ({
  updatePassword: Yup.object().shape({
    new_password: Yup.string().required(t('sendPasswordDialog.newPasswordRequired')),
  }),
});

export default agentValidation;
